var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { TitleBar } from "@shopify/app-bridge-react";
// import {QuestionMarkInverseMajor} from '@shopify/polaris-icons';
import { currentBusinessIdVar, primaryActionLoadingVar, currentSubscriptionBenefitVar, membershipsHaveBeenEditedVar, dummyFunc, startPrimaryAction, completePrimaryAction, pageHasUnsavedChangesVar } from "../helpers/client";
import { calculateDefaultCurationValue } from "../helpers/calculator";
import { saveMemberships } from "../../src/cache/transformers";
import { useWithfriendsTitleBarUpdateBusinessMutation, useWithfriendsTitleBarLaunchBusinessMutation, useWithfriendsTitleBarBusinessQuery, useWithfriendsTitleBarBusiness2Query, useUpdateThemeMutation, UpdateThemeFieldInputFragmentDoc, UpdateBusinessFragmentDoc, UpdateThemeFragmentDoc, } from "../types";
import { GetBenefitAllDocument, useUpdateBenefitMutation, } from "../../src/types";
import { Banner } from "@shopify/polaris";
import { gql, useApolloClient, useReactiveVar } from "@apollo/client";
import { Toast, useAppBridge } from "@shopify/app-bridge-react";
import { Redirect } from "@shopify/app-bridge/actions";
import { prepareSubscriptionBenefitInput } from "../cache/SubscriptionBenefitFunctions";
import { useTrackingCode } from "react-hubspot-tracking-code-hook";
gql `

fragment TitleBarBusiness on Business {
  id
  alias
  name
  dashboardLink
  oneLiner
  mission
  shopifyVersion
  status
  theme {
    id
  }
  enableProductSwapping
  enableAutomatedCuration
  includeWelcomeGiftInFirstShipment
  onboardingTasksUrl
}

query WithfriendsTitleBarBusiness2($id: ID!) {
  business(id: $id) {
    shopifyTosAccepted
    shopifyProductsPublished
    shopifyCollectionsPublished
    shopifyThemeVersion
    shopifyAppBlockPublished
  }
}

query WithfriendsTitleBarBusiness($id: ID!) {
  business(id: $id) {
    id
    membershipTiers(kind:Live) {
      id
      name
      defaultMode
      overridePlatformProductSync
      plans {
        kind
        price {
          amount
        }
      }
      discounts {
        scope
        percentage
        guests
      }
      benefits {
        __typename
        id
        name
        ...on SubscriptionBenefit {
          delivery
          nextShipmentDate
          isAddonOnly
          shippingFrequency {
            number
            period
          }
          deliveryFrequency
          firstShipmentDelay
          variants {
            id
            description
            additionalCost {
              amount
            }
            platformName
            platformId
          }
          addons {
            id
            description
            applyDiscount
            dontRollOver
            platformId
            platformName
            additionalCost {
              amount
            }
          }
        }
      }
    }
    ...TitleBarBusiness
  }
}

mutation WithfriendsTitleBarUpdateBusiness($id: ID!, $business: BusinessInput!) {
  updateBusiness(id: $id, business: $business) {
    ...TitleBarBusiness
  }
}

mutation WithfriendsTitleBarLaunchBusiness($id: ID!) {
  launchBusiness(id: $id) {
    success
    error
    message
  }
}
`;
export var WithfriendsAction;
(function (WithfriendsAction) {
    WithfriendsAction[WithfriendsAction["Setup"] = 0] = "Setup";
    WithfriendsAction[WithfriendsAction["Link"] = 1] = "Link";
    WithfriendsAction[WithfriendsAction["Analytics"] = 2] = "Analytics";
    WithfriendsAction[WithfriendsAction["Memberships"] = 3] = "Memberships";
    WithfriendsAction[WithfriendsAction["Brand"] = 4] = "Brand";
    WithfriendsAction[WithfriendsAction["Experience"] = 5] = "Experience";
    WithfriendsAction[WithfriendsAction["Reports"] = 6] = "Reports";
    WithfriendsAction[WithfriendsAction["Customers"] = 7] = "Customers";
    WithfriendsAction[WithfriendsAction["Launch"] = 8] = "Launch";
    WithfriendsAction[WithfriendsAction["Advanced"] = 9] = "Advanced";
    WithfriendsAction[WithfriendsAction["Fulfillments"] = 10] = "Fulfillments";
    WithfriendsAction[WithfriendsAction["Events"] = 11] = "Events";
    WithfriendsAction[WithfriendsAction["SaveMemberships"] = 12] = "SaveMemberships";
    WithfriendsAction[WithfriendsAction["SaveSubscriptionBenefit"] = 13] = "SaveSubscriptionBenefit";
    WithfriendsAction[WithfriendsAction["SaveBrand"] = 14] = "SaveBrand";
    WithfriendsAction[WithfriendsAction["SaveExperience"] = 15] = "SaveExperience";
    WithfriendsAction[WithfriendsAction["LaunchBusiness"] = 16] = "LaunchBusiness";
    WithfriendsAction[WithfriendsAction["Support"] = 17] = "Support";
    WithfriendsAction[WithfriendsAction["OnboardingTasks"] = 18] = "OnboardingTasks";
})(WithfriendsAction || (WithfriendsAction = {}));
const WithfriendsTitleBar = ({ action, crumbs, primaryAction, secondaryActions, title: titleInput, useSyncShopifyDataMutation = dummyFunc }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    var app = null;
    try {
        app = useAppBridge();
    }
    catch (e) {
        console.log(e);
    }
    const client = useApolloClient();
    const [toastZone, setToastZone] = useState(null);
    const [bannerZone, setBannerZone] = useState(null);
    const currentBusinessId = useReactiveVar(currentBusinessIdVar);
    const currentSubscriptionBenefitId = useReactiveVar(currentSubscriptionBenefitVar);
    const primaryActionLoading = useReactiveVar(primaryActionLoadingVar);
    const membershipsHaveBeenEdited = useReactiveVar(membershipsHaveBeenEditedVar);
    const [updateBusiness] = useWithfriendsTitleBarUpdateBusinessMutation();
    const [launchBusiness] = useWithfriendsTitleBarLaunchBusinessMutation();
    const [updateBenefit] = useUpdateBenefitMutation({
        update: (cache, { data: { updateBenefit } }) => cache.modify({
            id: `${updateBenefit.__typename}:${updateBenefit.id}`,
            fields: {
                name: () => updateBenefit.name
            }
        })
    });
    const { setPathPageView } = useTrackingCode();
    // KGAUDIT - why does it explicitly say cache-first when that's the default?
    const { data, refetch } = useWithfriendsTitleBarBusinessQuery({
        variables: {
            id: currentBusinessId
        },
        fetchPolicy: "cache-first",
        nextFetchPolicy: "cache-only",
        skip: !currentBusinessId,
    });
    const { data: data2 } = useWithfriendsTitleBarBusiness2Query({
        variables: {
            id: currentBusinessId
        },
        fetchPolicy: "cache-first",
        skip: ((_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.shopifyVersion) != 2,
    });
    const completedPostLaunch = (((_b = data === null || data === void 0 ? void 0 : data.business) === null || _b === void 0 ? void 0 : _b.status) === "Live"
        && ((_c = data2 === null || data2 === void 0 ? void 0 : data2.business) === null || _c === void 0 ? void 0 : _c.shopifyTosAccepted)
        && ((_d = data2 === null || data2 === void 0 ? void 0 : data2.business) === null || _d === void 0 ? void 0 : _d.shopifyProductsPublished)
        && ((_e = data2 === null || data2 === void 0 ? void 0 : data2.business) === null || _e === void 0 ? void 0 : _e.shopifyCollectionsPublished)
        && (((_f = data2 === null || data2 === void 0 ? void 0 : data2.business) === null || _f === void 0 ? void 0 : _f.shopifyThemeVersion) != 2 || ((_g = data2 === null || data2 === void 0 ? void 0 : data2.business) === null || _g === void 0 ? void 0 : _g.shopifyAppBlockPublished)));
    // TODO - I just wanna fetch this query above to be consistent in apollo
    if (!app)
        return null;
    const redirect = Redirect.create(app);
    const [syncToShopify] = useSyncShopifyDataMutation({
        variables: {
            id: currentBusinessId
        },
        skip: !currentBusinessId,
    });
    const nullToast = () => { setToastZone(null); };
    const saveSubscriptionBenefitOnAction = async () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        startPrimaryAction();
        // mixpanel.track("Subscription Box", { action: "Saved Subscription Benefit" })
        const data = client.readQuery({
            query: GetBenefitAllDocument,
            variables: { id: currentSubscriptionBenefitId }
        });
        await saveMemberships(currentBusinessId, client, {}, data.benefit.membershipTiers.map(tier => tier.id));
        let defaultCurationValue = 0;
        const monthlyPrice = (_e = (_d = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.benefit) === null || _a === void 0 ? void 0 : _a.membershipTiers[0]) === null || _b === void 0 ? void 0 : _b.plans) === null || _c === void 0 ? void 0 : _c.find(plan => plan.kind == "MONTHLY")) === null || _d === void 0 ? void 0 : _d.price) === null || _e === void 0 ? void 0 : _e.amount;
        if (monthlyPrice) {
            defaultCurationValue = calculateDefaultCurationValue((_g = (_f = data === null || data === void 0 ? void 0 : data.benefit) === null || _f === void 0 ? void 0 : _f.shippingFrequency) === null || _g === void 0 ? void 0 : _g.period, (_h = data === null || data === void 0 ? void 0 : data.benefit) === null || _h === void 0 ? void 0 : _h.deliveryFrequency, monthlyPrice);
        }
        const benefitKey = data.benefit.__typename === "SubscriptionBenefit"
            ? "subscription"
            : data.benefit.__typename === "WelcomeGiftBenefit"
                ? "welcomeGift"
                : "drive";
        let benefitValue = prepareSubscriptionBenefitInput(data.benefit, data.benefit.business.enableAutomatedCuration, defaultCurationValue);
        if (benefitKey === "drive") {
            const { variants, shippingFrequency, delivery, deliveryFrequency, firstShipmentDelay } = benefitValue, restOfBenefitValue = __rest(benefitValue, ["variants", "shippingFrequency", "delivery", "deliveryFrequency", "firstShipmentDelay"]);
            benefitValue = restOfBenefitValue;
        }
        const variables = {
            id: currentSubscriptionBenefitId,
            benefit: {
                [benefitKey]: benefitValue
            }
        };
        await updateBenefit({ variables });
        const businessVariables = {
            id: data.benefit.business.id,
            business: data.benefit.__typename == "SubscriptionBenefit" ? {
                enableAutomatedCuration: (_k = (_j = data.benefit) === null || _j === void 0 ? void 0 : _j.business) === null || _k === void 0 ? void 0 : _k.enableAutomatedCuration,
                enableProductSwapping: (_m = (_l = data.benefit) === null || _l === void 0 ? void 0 : _l.business) === null || _m === void 0 ? void 0 : _m.enableProductSwapping
            } : {
                includeWelcomeGiftInFirstShipment: (_p = (_o = data.benefit) === null || _o === void 0 ? void 0 : _o.business) === null || _p === void 0 ? void 0 : _p.includeWelcomeGiftInFirstShipment
            }
        };
        await updateBusiness({ variables: businessVariables });
        completePrimaryAction();
        setToastZone(_jsx(Toast, { content: "Benefit Saved!", onDismiss: nullToast }));
        redirect.dispatch(Redirect.Action.APP, "/memberships");
    };
    const saveMembershipsOnAction = async () => {
        startPrimaryAction();
        // mixpanel.track("Membership Tiers", { action: "Saved Memberships" })
        try {
            await saveMemberships(currentBusinessId, client, { makeNonDefault: membershipsHaveBeenEdited });
            await syncToShopify();
            pageHasUnsavedChangesVar(false);
            membershipsHaveBeenEditedVar(false);
        }
        catch (err) {
            process.env.NODE_ENV === "development" && console.log(err);
            setBannerZone(_jsx("div", { className: "mb-12 mx-auto max-w-4xl", children: _jsx(Banner, { title: "Error saving your memberships", tone: "critical", onDismiss: () => { setBannerZone(null); }, children: _jsx("p", { children: "Please try again, or reach out to us in the chat bubble in the lower right corner if the problem persists." }) }) }));
            completePrimaryAction();
            return;
        }
        completePrimaryAction();
        setToastZone(_jsx(Toast, { content: "Memberships Saved!", onDismiss: nullToast }));
    };
    const [updateTheme] = useUpdateThemeMutation();
    const saveExperienceOnAction = async () => {
        var _a, _b;
        startPrimaryAction();
        try {
            const businessCacheData = client.readFragment({
                id: `Business:${currentBusinessId}`,
                fragmentName: "UpdateBusiness",
                fragment: UpdateBusinessFragmentDoc
            });
            await updateBusiness({
                variables: {
                    id: currentBusinessId,
                    business: businessCacheData,
                },
            });
            // Theme
            if ((_b = (_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.theme) === null || _b === void 0 ? void 0 : _b.id) {
                const themeCacheData = client.readFragment({
                    id: `Theme:${data.business.theme.id}`,
                    fragment: UpdateThemeFragmentDoc,
                });
                const themeUpdateParams = {
                    variables: {
                        businessId: currentBusinessId,
                        theme: themeCacheData,
                    },
                };
                await updateTheme(themeUpdateParams);
            }
            await syncToShopify();
            completePrimaryAction();
            setToastZone(_jsx(Toast, { content: "Experience Saved!", onDismiss: nullToast }));
        }
        catch (err) {
            setBannerZone(_jsx("div", { className: "mb-12 mx-auto max-w-4xl", children: _jsx(Banner, { title: "Error saving your experience", tone: "critical", onDismiss: () => { setBannerZone(null); }, children: _jsx("p", { children: "Please try again, or reach out to us in the chat bubble in the lower right corner if the problem persists." }) }) }));
            completePrimaryAction();
        }
    };
    const saveBrandOnAction = async () => {
        var _a, _b;
        startPrimaryAction();
        try {
            const businessCacheData = client.readFragment({
                id: `Business:${currentBusinessId}`,
                fragmentName: "UpdateBusiness",
                fragment: UpdateBusinessFragmentDoc
            });
            await updateBusiness({
                variables: {
                    id: currentBusinessId,
                    business: businessCacheData,
                },
            });
            // Theme
            if ((_b = (_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.theme) === null || _b === void 0 ? void 0 : _b.id) {
                const themeCacheData = client.readFragment({
                    id: `Theme:${data.business.theme.id}`,
                    fragment: UpdateThemeFieldInputFragmentDoc,
                });
                const themeUpdateParams = {
                    variables: {
                        businessId: currentBusinessId,
                        theme: themeCacheData,
                    },
                };
                await updateTheme(themeUpdateParams);
            }
            await syncToShopify();
            completePrimaryAction();
            setToastZone(_jsx(Toast, { content: "Brand Saved!", onDismiss: nullToast }));
        }
        catch (err) {
            setBannerZone(_jsx("div", { className: "mb-12 mx-auto max-w-4xl", children: _jsx(Banner, { title: "Error saving your brand", tone: "critical", onDismiss: () => { setBannerZone(null); }, children: _jsx("p", { children: "Please try again, or reach out to us in the chat bubble in the lower right corner if the problem persists." }) }) }));
            completePrimaryAction();
        }
    };
    const launchBusinessOnAction = async () => {
        var _a, _b, _c, _d, _e, _f;
        primaryActionLoadingVar(true);
        // mixpanel.track("Launch Business", { action: "Launch Initiated" })
        try {
            await saveBrandOnAction();
            const response = await launchBusiness({
                variables: {
                    id: currentBusinessId,
                },
            });
            if ((_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.launchBusiness) === null || _b === void 0 ? void 0 : _b.success) { }
            else if ((_d = (_c = response.data) === null || _c === void 0 ? void 0 : _c.launchBusiness) === null || _d === void 0 ? void 0 : _d.error) {
                switch ((_f = (_e = response.data) === null || _e === void 0 ? void 0 : _e.launchBusiness) === null || _f === void 0 ? void 0 : _f.error) {
                    case "Has default memberships":
                        primaryActionLoadingVar(false);
                        setToastZone(null);
                        setBannerZone(_jsx("div", { className: "mb-12 mx-auto max-w-4xl", children: _jsx(Banner, { title: "You haven't changed your memberships.", tone: "critical", onDismiss: () => { setBannerZone(null); }, children: _jsx("p", { children: "Please make a few tweaks before launching." }) }) }));
                        return;
                    case "Has no Stripe user":
                    case "Cannot add membership on Stripe":
                    case "Cannot create adjustment on Stripe":
                    case "Unknown":
                    case "Badly formed request":
                    case "401":
                    case "Not authorized":
                    case "Internal Server Error":
                    default:
                        primaryActionLoadingVar(false);
                        setToastZone(null);
                        // mixpanel.track("Launch Business", { action: "Launch Failed" })
                        setBannerZone(_jsx("div", { className: "mb-12 mx-auto max-w-4xl", children: _jsx(Banner, { title: "Server error occurred.", tone: "critical", onDismiss: () => { setBannerZone(null); }, children: _jsx("p", { children: "Withfriends Team has been notified.  Please reach out to us in the chat bubble in the lower right corner" }) }) }));
                        return;
                }
            }
            else {
                primaryActionLoadingVar(false);
                setToastZone(null);
                // mixpanel.track("Launch Business", { action: "Launch Failed" })
                setBannerZone(_jsx("div", { className: "mb-12 mx-auto max-w-4xl", children: _jsx(Banner, { title: "Server error occurred.", tone: "critical", onDismiss: () => { setBannerZone(null); }, children: _jsx("p", { children: "Withfriends Team has been notified.  Please reach out to us in the chat bubble in the lower right corner" }) }) }));
                return;
            }
        }
        catch (err) {
            primaryActionLoadingVar(false);
            setToastZone(null);
            // mixpanel.track("Launch Business", { action: "Launch Failed" })
            setBannerZone(_jsx("div", { className: "mb-12 mx-auto max-w-4xl", children: _jsx(Banner, { title: "Server error occurred.", tone: "critical", onDismiss: () => { setBannerZone(null); }, children: _jsx("p", { children: "Withfriends Team has been notified.  Please reach out to us in the chat bubble in the lower right corner" }) }) }));
            return;
        }
        primaryActionLoadingVar(false);
        setToastZone(null);
        // mixpanel.track("Launch Business", { action: "Launch Succeeded" })
        setToastZone(_jsx(Toast, { content: "Business Launched!", onDismiss: nullToast }));
    };
    const getAction = (option) => {
        var _a;
        switch (option) {
            case WithfriendsAction.Setup:
                return {
                    content: "Setup Withfriends",
                    url: "/setup",
                    target: "APP",
                };
            case WithfriendsAction.Link:
                return {
                    content: "Link Business",
                    url: "/link",
                    target: "APP",
                };
            case WithfriendsAction.Analytics:
                return {
                    content: "Customer Analytics",
                    url: "/analytics",
                    target: "APP",
                };
            case WithfriendsAction.Memberships:
                return {
                    content: "Membership Tiers",
                    url: "/memberships",
                    target: "APP",
                };
            case WithfriendsAction.Brand:
                return {
                    content: "Brand",
                    url: "/brand",
                    target: "APP",
                };
            case WithfriendsAction.Experience:
                return {
                    content: "Experience",
                    url: "/experience",
                    target: "APP",
                };
            case WithfriendsAction.Launch:
                return {
                    content: "Launch",
                    url: "/launch",
                    target: "APP",
                };
            case WithfriendsAction.Reports:
                return {
                    content: "Reports",
                    url: "/reports",
                    target: "APP",
                };
            case WithfriendsAction.Customers:
                return {
                    content: "Your Members",
                    url: "/customers",
                    target: "APP",
                };
            case WithfriendsAction.Advanced:
                return {
                    content: "Advanced Options",
                    url: "/advanced",
                    target: "APP",
                };
            case WithfriendsAction.Fulfillments:
                return {
                    content: "Manage Fulfillments",
                    url: "/fulfillments",
                    target: "APP",
                };
            case WithfriendsAction.Events:
                return {
                    content: "Manage Events",
                    url: "/events",
                    target: "APP",
                };
            case WithfriendsAction.Support:
                return {
                    content: "Knowledge Base",
                    url: "https://help.withfriends.co/8683156-managing-member-requests",
                    target: "REMOTE",
                    // icon: QuestionMarkInverseMajor,
                    external: true,
                };
            case WithfriendsAction.OnboardingTasks:
                return {
                    content: "Onboarding Tasks",
                    url: (_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.onboardingTasksUrl,
                    target: "REMOTE",
                    external: true,
                };
            case WithfriendsAction.SaveMemberships:
                return {
                    content: primaryActionLoading ? "Saving Memberships..." : "Save Memberships",
                    onAction: saveMembershipsOnAction,
                };
            case WithfriendsAction.SaveSubscriptionBenefit:
                return {
                    content: primaryActionLoading ? "Saving Subscription Box..." : "Save Subscription Box",
                    onAction: saveSubscriptionBenefitOnAction,
                };
            case WithfriendsAction.SaveBrand:
                return {
                    content: primaryActionLoading ? "Saving Brand..." : "Save Brand",
                    onAction: saveBrandOnAction,
                };
            case WithfriendsAction.SaveExperience:
                return {
                    content: primaryActionLoading ? "Saving Experience..." : "Save Experience",
                    onAction: saveExperienceOnAction,
                };
            case WithfriendsAction.LaunchBusiness:
                return {
                    content: primaryActionLoading ? "Launching Business..." : "Launch Business",
                    onAction: launchBusinessOnAction,
                };
            default:
                return null;
        }
    };
    const title = titleInput || getAction(action).content;
    const breadcrumbs = ((crumbs === null || crumbs === void 0 ? void 0 : crumbs.map(getAction)) || []);
    useEffect(() => {
        var _a, _b;
        if (((_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.shopifyVersion) == 2)
            setPathPageView((_b = getAction(action)) === null || _b === void 0 ? void 0 : _b.url);
    }, [data]);
    useEffect(() => {
        // Launch is handled in Launch screen because it's a special case
        // if (action != WithfriendsAction.Launch)
        //   mixpanel.track(getAction(action)?.content, { action: "Viewed" })
    }, []);
    if (!data)
        return (_jsxs(_Fragment, { children: [_jsx(TitleBar, { title: title }), toastZone] }));
    const actionGroups = () => [{
            title: title,
            actions: (() => {
                var _a, _b;
                const baseActions = (((_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.shopifyVersion) == 2 ? [
                    ...(!completedPostLaunch ? [
                        WithfriendsAction.Setup,
                        WithfriendsAction.Analytics,
                    ] : []),
                    WithfriendsAction.Memberships,
                    WithfriendsAction.Brand,
                    WithfriendsAction.Experience,
                    WithfriendsAction.Launch,
                    WithfriendsAction.Reports,
                    WithfriendsAction.Customers,
                    WithfriendsAction.Fulfillments,
                    WithfriendsAction.Events,
                    WithfriendsAction.Advanced,
                    WithfriendsAction.Support,
                ] : [
                    WithfriendsAction.Setup,
                    WithfriendsAction.Analytics,
                    WithfriendsAction.Memberships,
                    WithfriendsAction.Brand,
                    WithfriendsAction.Experience,
                    WithfriendsAction.Launch,
                    WithfriendsAction.Reports,
                    WithfriendsAction.Events,
                    WithfriendsAction.Advanced,
                ]);
                // Add OnboardingTasks if onboardingTasksUrl is non-empty/non-null
                if ((_b = data === null || data === void 0 ? void 0 : data.business) === null || _b === void 0 ? void 0 : _b.onboardingTasksUrl) {
                    baseActions.push(WithfriendsAction.OnboardingTasks);
                }
                return baseActions.map(getAction);
            })()
        }];
    return (_jsxs(_Fragment, { children: [_jsx(TitleBar, { title: title, primaryAction: getAction(primaryAction), secondaryActions: secondaryActions ? secondaryActions.map(getAction) : undefined, actionGroups: actionGroups(), breadcrumbs: breadcrumbs }), bannerZone, toastZone] }));
};
export default WithfriendsTitleBar;
